<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="dark text-white bg-neutral-800 w-[800px] h-full flex flex-col"
>
  <div
    class="flx-modal-title text-white"
    flxModalHeaderTitle
  >
    {{ action.name }} - Set Source
  </div>

  <div
    class="flx-modal-subtitle text-neutral-400 text-sm"
    flxModalHeaderSubtitle
  >
    Add extra information (from documents or images) about the resource to be generated.
  </div>

  <flx-segmented-button
    [ngModel]="selectedTab()"
    (ngModelChange)="selectedTab.set($event)"
    class="header-segmented-button p-1 rounded-lg bg-neutral-900 w-full mb-8"
  >
    @for (tab of tabs; track tab.value) {
      <button
        [value]="tab.value"
        [ngClass]="{
          'text-neutral-400': tab.disabled,
          'pointer-events-none': tab.disabled,
        }"
        class="h-6 text-xs rounded [&:not(.selected)]:bg-neutral-900 text-white border-0"
        flxSegmentedOption
      >
        {{ tab.label }}
      </button>
    }
  </flx-segmented-button>

  @if (fileUploadConfig()) {
    <flx-file-source-upload
      [config]="fileUploadConfig()"
      [initialFiles]="selectedTab() === initialFileType && initialFile ? [initialFile] : []"
      (fileSelected)="onFileSelected($event)"
      (uploadError)="onUploadError($event)"
    />
  }

  <div class="w-full flex flex-row justify-center items-center gap-4 mt-8">
    <button
      (click)="closeModal()"
      class="flx-ds secondary w-full text-blue-500"
      flxButton
      type="button"
      variant="ghost"
    >
      Discard
    </button>
    <button
      [disabled]="!hasSelectedSource()"
      (click)="save()"
      class="flx-ds primary w-full enabled:!bg-blue-500 enabled:hover:!bg-blue-600"
      flxButton
      type="button"
    >
      Save Source Settings
    </button>
  </div>
</flx-modal>
